module.exports = __webpack_public_path__ + "static/zebrablanket-25e206838cbbd7b1be24e2c8280a6d1c.png";